document.addEventListener('DOMContentLoaded',()=>{
  const productGrid=document.querySelector('[data-collection-product-grid]');
  const autoLoad=document.querySelector('[data-collection-auto-load]');
  if(!productGrid||!autoLoad)return;
  let nextUrl=autoLoad.querySelector('[data-collection-next]')?.href;
  const loadAll=async()=>{
    try{
      while(nextUrl){
        const response=await fetch(nextUrl,{headers:{'X-Requested-With':'XMLHttpRequest'}});
        if(!response.ok)throw new Error('Could not load the next collection page');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const nextGrid=doc.querySelector('[data-collection-product-grid]');
        if(!nextGrid)throw new Error('Collection grid was not found');
        [...nextGrid.children].forEach(card=>productGrid.appendChild(card));
        document.dispatchEvent(new CustomEvent('rv:products-updated'));
        nextUrl=doc.querySelector('[data-collection-next]')?.href;
      }
      autoLoad.remove();
      document.dispatchEvent(new CustomEvent('rv:products-updated'));
    }catch(error){
      autoLoad.classList.add('has-error');
      const label=autoLoad.querySelector('span:last-of-type');
      const link=autoLoad.querySelector('[data-collection-next]');
      if(label)label.textContent='More pieces are available.';
      if(link){link.href=nextUrl||link.href;link.textContent='Load more pieces';}
    }
  };
  window.rvAllProductsPromise=loadAll();
});
